import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationIndexService } from './confirmation-index.service';

import { CANCEL_STATUS } from '../shared/constants/cancel-status';
import { MODAL_STATUS } from '../shared/constants/modal';
export class ConfirmationIndexComponent implements OnInit {
   statusCancelCb = new EventEmitter<string>();
public profile: any;
public loan: any;
public data: any;
public xauth: any;
public MODAL_STATUS = MODAL_STATUS;
public CANCEL_STATUS = CANCEL_STATUS;
/**
 * @param {?} service
 */
constructor(public service: ConfirmationIndexService) {
    this.service.dataStore.subscribe(res => {
      if (res.statusCancel === CANCEL_STATUS.ACCEPTED) {
        this.handleCancelAccepted();
      }
      this.data = res;
    });
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.service.getRejReasonsList();
    this.service.buildForm();

    this.service.setStore({
      profile: this.profile,
      loan: this.loan,
    });
    this.checkStatusCancel();
  }
/**
 * @return {?}
 */
checkStatusCancel(): void {
    if (!this.data.loan.confirmed) {
      this.service.checkStatusCancel();
    }
  }
/**
 * @return {?}
 */
handleCancelAccepted(): void {
    this.statusCancelCb.emit('Tidak Disetujui');
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'confirmation-index',
  template: `
    <ng-container *ngIf="data.statusCancel === CANCEL_STATUS.PENDING">
      <div class="tnk-card">
        <div class="tnk-card__header">
          <h1>Pembatalan Pinjaman Anda sedang Diproses</h1>
        </div>
        <div class="tnk-card__body">
          <div class="tnk-padding">
            <div class="main-content">
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    Mohon tunggu beberapa saat lagi, pembatalan pinjaman Anda sedang
                    kami proses, Silahkan tekan tombol di bawah ini untuk mengetahui
                    status terbaru Anda.
                  </div>
                  <div class="alert alert-warning">
                    Status pembatalan Anda masih diproses
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <button
            id="btn-check-status-cancel"
            class="tnk-button tnk-button__green block active"
            [ngClass]="{ busy: data.isFetching }"
            (click)="checkStatusCancel()"
          >
            <span *ngIf="data.isFetching" class="fa fa-spinner fa-spin"></span>
            Cek Status Anda
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="data.statusCancel !== CANCEL_STATUS.PENDING">
      <div class="tnk-card">
        <div class="tnk-card__header">
          <h1>Segera konfirmasi pinjaman Anda</h1>
        </div>
        <div class="tnk-card__body">
          <div class="tnk-padding">
            <div class="main-content">
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    Selamat! Pinjaman Anda telah kami setujui. Berdasarkan Sistem
                    Scoring Tunaiku, Anda layak mendapat pinjaman dengan:
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    <div class="row">
                      <div class="col-xs-6">
                        Nomor Pinjaman
                      </div>
                      <div class="col-xs-6">
                        <strong>{{ loan.id }}</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6">
                        Jumlah Pinjaman
                      </div>
                      <div class="col-xs-6">
                        <strong>{{ loan.amount | tnkCurrency: 'rupiah' }}</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6">
                        Lama Cicilan
                      </div>
                      <div class="col-xs-6">
                        <strong>{{ loan.period }} Bulan</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    Jumlah dan tenor yang disetujui bisa jadi berbeda dari pengajuan
                    Anda. Jika Anda setuju, silakan klik tombol “
                    <strong>Lanjutkan Form Konfirmasi</strong>
                    ”. Formulir ini cukup diisi dan dikirimkan sekali saja.
                    <!-- Jika tidak ingin mengambil pinjaman, Anda cukup klik tombol “Batalkan
                    pinjaman”. -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    <p>
                      <!-- <button
                        [disabled]="
                          data.loan.confirmed ||
                          data.statusCancel === CANCEL_STATUS.NOT_ACCEPTED ||
                          data.statusCancel === CANCEL_STATUS.ACCEPTED
                        "
                        [ngClass]="{
                          active: data.isCancel,
                          disabled:
                            data.loan.confirmed ||
                            data.statusCancel === CANCEL_STATUS.NOT_ACCEPTED ||
                            data.statusCancel === CANCEL_STATUS.ACCEPTED
                        }"
                        class="tnk-button__blue"
                        (click)="service.cancelLoan()"
                      >
                        Batalkan Pinjaman
                      </button> -->
                      <button
                        [disabled]="
                          data.loan.confirmed ||
                          data.statusCancel === CANCEL_STATUS.ACCEPTED
                        "
                        [ngClass]="{
                          disabled:
                            data.loan.confirmed ||
                            data.statusCancel === CANCEL_STATUS.ACCEPTED
                        }"
                        class="tnk-button__green"
                        (click)="service.nextForm()"
                      >
                        Lanjut Form Konfirmasi
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="cancel-content" *ngIf="data.isCancel">
            <div class="tnk-padding">
              <div class="row">
                <div class="col-xs-12">
                  <h1>Apa alasan Anda membatalkan pinjaman di Tunaiku?</h1>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="p-y">
                    <h4>bantu kami mengetahui alasan pembatalan anda</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <form [formGroup]="data.cancelForm">
                    <div *ngFor="let reason of data.rejReasonsList" class="radio">
                      <label>
                        <input
                          type="radio"
                          formControlName="reasonEnum"
                          name="reasonEnum"
                          [value]="reason.enumeration"
                        />
                        {{ reason.description_id }}
                      </label>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <button
                    [ngClass]="{ disabled: !data.cancelForm.valid }"
                    class="tnk-button__green active block"
                    [disabled]="!data.cancelForm.valid"
                    (click)="service.sentCancelLoan()"
                  >
                    kirim
                  </button>
                </div>
              </div>
            </div>
          </div>

          <ng-container
            *ngIf="
              data.statusCancel === CANCEL_STATUS.NOT_ACCEPTED &&
              !data.loan.confirmed
            "
          >
            <div class="row">
              <div class="col-xs-12">
                <div class="alert alert-danger">
                  <h5>Pembatalan Pinjaman Gagal Terkirim</h5>
                  <p>
                    Mohon maaf ada kesalahan dengan sistem kami, mohon segera
                    hubungi
                    <strong>(021)4000-5859</strong>
                    untuk membatalkan pinjaman secara manual
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <tnk-modal [isOpen]="data.modal == MODAL_STATUS.SUCCESS">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">Pembatalan Anda sudah terkirim!</h5>
        <p>
          Mohon menunggu sampai pembatalan Anda diproses dan status pengajuan Anda
          diperbarui sistem kami.
        </p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeSuccessModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>

    <tnk-modal [isOpen]="data.modal == MODAL_STATUS.FAILED">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">Maaf terjadi kesalahan</h5>
        <p>Terjadi kesalahan. Silahkan cek kembali form Anda.</p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>

    <tnk-modal [isOpen]="data.modal == MODAL_STATUS.ERROR">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">
          Mohon maaf terdapat kesalahan dengan sistem kami
        </h5>
        <p>Mohon maaf terjadi masalah server. Silakan coba beberapa saat lagi.</p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>

    <tnk-modal
      [isOpen]="data.modal == MODAL_STATUS.FAILED_TO_CANCEL && !data.loan.confirmed"
    >
      <tnk-modal-body class="tnk-align--center">
        <img src="assets/images/icon-failed-cancel.png" alt="Icon Failed Cancel" />
        <h5 class="tnk-color--secondary">Pembatalan Pinjaman Gagal Terkirim</h5>
        <p>
          Mohon maaf ada kesalahan dengan sistem kami, mohon segera hubungi
          <strong>(021)4000-5859</strong>
          untuk membatalkan pinjaman secara manual.
        </p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeModal()"
        >
          Kembali ke Dasbor
        </button>
      </tnk-modal-footer>
    </tnk-modal>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationIndexService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'statusCancelCb': [{ type: Output },],
'profile': [{ type: Input, args: ['profile', ] },],
'loan': [{ type: Input, args: ['loan', ] },],
};
}

function ConfirmationIndexComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationIndexComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationIndexComponent.ctorParameters;
/** @type {?} */
ConfirmationIndexComponent.propDecorators;
/** @type {?} */
ConfirmationIndexComponent.prototype.statusCancelCb;
/** @type {?} */
ConfirmationIndexComponent.prototype.profile;
/** @type {?} */
ConfirmationIndexComponent.prototype.loan;
/** @type {?} */
ConfirmationIndexComponent.prototype.data;
/** @type {?} */
ConfirmationIndexComponent.prototype.xauth;
/** @type {?} */
ConfirmationIndexComponent.prototype.MODAL_STATUS;
/** @type {?} */
ConfirmationIndexComponent.prototype.CANCEL_STATUS;
/** @type {?} */
ConfirmationIndexComponent.prototype.service;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
